var _style, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107.4 100",
    style: {
      enableBackground: "new 0 0 107.4 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000139981451998904176150000003231607247073692073_);}\r\n\t.st2{fill:url(#SVGID_00000144312047555833287370000004785269780723613608_);}\r\n\t.st3{fill:url(#SVGID_00000086667838448514737000000014292633412017355964_);}\r\n\t.st4{fill:url(#SVGID_00000073721918199567567030000015885754009733334402_);}\r\n\t.st5{fill:url(#SVGID_00000109028428159031577450000002818033504620709288_);}\r\n\t.st6{fill:url(#SVGID_00000025408686536289546850000003174396052500723895_);}\r\n\t.st7{fill:url(#SVGID_00000133520143480811997680000014163500271312868532_);}\r\n\t.st8{fill:url(#SVGID_00000034076224128925151710000010280337458822577280_);}\r\n\t.st9{fill:url(#SVGID_00000017512765718762377920000006654402561702502047_);}\r\n\t.st10{fill:url(#SVGID_00000077300145867463524160000012614500494419719056_);}\r\n\t.st11{fill:url(#SVGID_00000016064369331054939310000005965350127016341672_);}\r\n\t.st12{fill:url(#SVGID_00000137846638318190894800000015050398942950845326_);}\r\n\t.st13{fill:url(#SVGID_00000157291797538522525260000008000184442384747656_);}\r\n\t.st14{fill:url(#SVGID_00000083803795774874090620000010873887131401431952_);}\r\n\t.st15{fill:url(#SVGID_00000060005506848810723160000008506985681790719617_);}\r\n\t.st16{fill:url(#SVGID_00000003074380810598926830000014548750048773381822_);}\r\n\t.st17{fill:url(#SVGID_00000128451177804381846050000007801005965326099873_);}\r\n\t.st18{fill:url(#SVGID_00000122691385656439794200000010884381860278633350_);}\r\n\t.st19{fill:url(#SVGID_00000065066930862771494630000015762171377678845586_);}\r\n\t.st20{fill:url(#SVGID_00000156554525095781511370000018071215751125174716_);}\r\n\t.st21{fill:url(#SVGID_00000063597222991250939920000001347337891057113222_);}\r\n\t.st22{fill:url(#SVGID_00000080186666352080503200000017567052369704197514_);}\r\n\t.st23{fill:url(#SVGID_00000173846811655100495820000014549465601661283753_);}\r\n\t.st24{fill:url(#SVGID_00000030454628603153022750000007847323154950829494_);}\r\n\t.st25{fill:url(#SVGID_00000024702611367676020180000003550558528263431601_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1192,
    y1: 16.1223,
    x2: 44.4096,
    y2: 35.233
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.82,
    y: 20.69,
    className: "st0",
    width: 17.24,
    height: 6.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035522021891697333010000002487820972774425528_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.4935,
    y1: 5.8098,
    x2: 68.7844,
    y2: 102.9215
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035522021891697333010000002487820972774425528_)"
    },
    d: "M29.82,62.07v10.34h6.9V62.07H29.82z  M29.82,62.07v10.34h6.9V62.07H29.82z M29.82,62.07v10.34h6.9V62.07H29.82z M29.82,62.07v10.34h6.9V62.07H29.82z M22.92,13.8v65.51 h31.03V13.8H22.92z M26.37,41.38h17.24v3.45H26.37V41.38z M40.16,75.86H26.37V58.62h13.79V75.86z M50.5,75.86h-6.9v-3.45h6.9V75.86z  M50.5,68.97h-6.9v-3.45h6.9V68.97z M50.5,62.07h-6.9v-3.45h6.9V62.07z M50.51,51.73H26.37v-3.45h24.14V51.73z M50.51,44.83h-3.45 v-3.45h3.45V44.83z M50.51,37.93H26.37v-3.45h24.14V37.93z M50.51,31.03H26.37V17.24h24.14V31.03z M36.71,62.07h-6.9v10.34h6.9 V62.07z M29.82,62.07v10.34h6.9V62.07H29.82z M29.82,62.07v10.34h6.9V62.07H29.82z M29.82,62.07v10.34h6.9V62.07H29.82z  M29.82,62.07v10.34h6.9V62.07H29.82z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015324495497813169480000007777694686970373783_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.3144,
    y1: -8.0938,
    x2: 94.6053,
    y2: 89.0179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015324495497813169480000007777694686970373783_)"
    },
    d: "M72.91,0H28.09 c-2.85,0-5.17,2.32-5.17,5.17v5.17h55.17V5.17C78.09,2.32,75.76,0,72.91,0z M29.68,5.83c-0.09,0.21-0.21,0.4-0.37,0.56 c-0.16,0.16-0.35,0.29-0.56,0.37c-0.21,0.09-0.43,0.13-0.66,0.13c-0.23,0-0.45-0.05-0.66-0.13c-0.21-0.09-0.4-0.21-0.56-0.37 c-0.16-0.16-0.29-0.35-0.37-0.56c-0.09-0.21-0.13-0.43-0.13-0.66c0-0.23,0.04-0.45,0.13-0.66c0.09-0.21,0.21-0.4,0.37-0.56 c0.16-0.16,0.34-0.29,0.56-0.37c0.21-0.09,0.43-0.13,0.66-0.13c0.23,0,0.45,0.04,0.66,0.13c0.21,0.09,0.4,0.21,0.56,0.37 c0.16,0.16,0.29,0.35,0.37,0.56c0.09,0.21,0.13,0.43,0.13,0.66C29.82,5.4,29.77,5.62,29.68,5.83z M36.58,5.83 c-0.09,0.21-0.21,0.4-0.37,0.56c-0.16,0.16-0.35,0.29-0.56,0.37c-0.21,0.09-0.43,0.13-0.66,0.13c-0.23,0-0.45-0.05-0.66-0.13 c-0.21-0.09-0.4-0.21-0.56-0.37c-0.16-0.16-0.29-0.35-0.37-0.56c-0.09-0.21-0.13-0.43-0.13-0.66c0-0.23,0.05-0.45,0.13-0.66 c0.09-0.21,0.21-0.4,0.37-0.56c0.16-0.16,0.35-0.29,0.56-0.37c0.21-0.09,0.43-0.13,0.66-0.13c0.23,0,0.45,0.04,0.66,0.13 c0.21,0.09,0.4,0.21,0.56,0.37c0.16,0.16,0.29,0.35,0.37,0.56c0.09,0.21,0.13,0.43,0.13,0.66C36.71,5.4,36.67,5.62,36.58,5.83z  M74.64,6.9H60.84V3.45h13.79V6.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049909930114539826160000017390521078835650225_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.4252,
    y1: 74.5239,
    x2: 52.4794,
    y2: 95.0531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049909930114539826160000017390521078835650225_)"
    },
    d: "M57.4,91.38c0,0.95-0.78,1.72-1.72,1.72 H45.33c-0.95,0-1.72-0.77-1.72-1.72c0-0.95,0.77-1.72,1.72-1.72h10.34C56.62,89.65,57.4,90.43,57.4,91.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145776628521356463340000008252977290504822972_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.9457,
    y1: 10.4125,
    x2: 60.2366,
    y2: 107.5241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145776628521356463340000008252977290504822972_)"
    },
    d: "M22.92,82.76v12.07 c0,2.85,2.32,5.17,5.17,5.17h44.83c2.85,0,5.17-2.32,5.17-5.17V82.76H22.92z M55.67,96.55H45.33c-2.86,0-5.17-2.32-5.17-5.17 c0-2.85,2.32-5.17,5.17-5.17h10.34c2.85,0,5.17,2.32,5.17,5.17C60.84,94.23,58.52,96.55,55.67,96.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076605483286780944490000013656053186058245285_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.6796,
    y1: -3.9827,
    x2: 86.9705,
    y2: 93.129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.01
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076605483286780944490000013656053186058245285_)"
    },
    d: "M60.84,55.17c-1.19,0-2.37-0.26-3.45-0.73 V38.66c1.08-0.47,2.25-0.73,3.45-0.73c4.75,0,8.62,3.87,8.62,8.62S65.6,55.17,60.84,55.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065069529498193171390000008627224888635821213_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.1693,
    y1: -13.4003,
    x2: 104.4602,
    y2: 83.7114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065069529498193171390000008627224888635821213_)"
    },
    d: "M57.4,17.24V13.8h20.69v8.55l-1.06-1.06 l-4.4,2.26c-1.23-0.63-2.51-1.16-3.84-1.59l-1.51-4.71H57.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052815831889215517560000008011245226806297225_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.326,
    y1: -0.0231,
    x2: 79.6169,
    y2: 97.0886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052815831889215517560000008011245226806297225_)"
    },
    d: "M77.02,71.82l1.06-1.06v8.55H57.4v-3.45 h9.88l1.51-4.71c1.33-0.43,2.62-0.96,3.84-1.58L77.02,71.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137104288648918943740000002258472726489355424_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.1001,
    y1: 8.985,
    x2: 48.6796,
    y2: 116.6227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137104288648918943740000002258472726489355424_)"
    },
    d: "M12.57,44.83H9.12 c-0.95,0-1.72-0.77-1.72-1.72c0-0.95,0.77-1.72,1.72-1.72h1.72c2.85,0,5.17-2.32,5.17-5.17c0-2.85-2.32-5.17-5.17-5.17H5.67 c-0.95,0-1.72-0.77-1.72-1.72c0-0.95,0.77-1.72,1.72-1.72h10.34v-3.45H5.67c-2.85,0-5.17,2.32-5.17,5.17 c0,2.85,2.32,5.17,5.17,5.17h5.17c0.95,0,1.72,0.77,1.72,1.72c0,0.95-0.77,1.72-1.72,1.72H9.12c-2.85,0-5.17,2.32-5.17,5.17 c0,2.85,2.32,5.17,5.17,5.17h3.45c0.95,0,1.72,0.77,1.72,1.72c0,0.95-0.77,1.72-1.72,1.72h-6.9c-2.85,0-5.17,2.32-5.17,5.17 c0,2.85,2.32,5.17,5.17,5.17h5.17c0.95,0,1.72,0.77,1.72,1.72c0,0.95-0.77,1.72-1.72,1.72H9.12c-2.85,0-5.17,2.32-5.17,5.17 c0,2.85,2.32,5.17,5.17,5.17h6.9v-3.45h-6.9c-0.95,0-1.72-0.77-1.72-1.72c0-0.95,0.77-1.72,1.72-1.72h1.72 c2.85,0,5.17-2.32,5.17-5.17c0-2.85-2.32-5.17-5.17-5.17H5.67c-0.95,0-1.72-0.77-1.72-1.72c0-0.95,0.77-1.72,1.72-1.72h6.9 c2.85,0,5.17-2.32,5.17-5.17C17.74,47.15,15.42,44.83,12.57,44.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142159245548130374720000004552271523388167321_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.1672,
    y1: -31.8221,
    x2: 120.9469,
    y2: 75.8156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.98,
    y: 24.14,
    style: {
      fill: "url(#SVGID_00000142159245548130374720000004552271523388167321_)"
    },
    width: 15.52,
    height: 3.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087402513464162290260000006598375936546233276_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.973,
    y1: -37.3591,
    x2: 130.7527,
    y2: 70.2786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087402513464162290260000006598375936546233276_)"
    },
    d: "M103.95,24.14h3.45v3.45h-3.45V24.14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058549278223317087020000009668972561986183596_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.5239,
    y1: -30.8942,
    x2: 119.3036,
    y2: 76.7435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058549278223317087020000009668972561986183596_)"
    },
    d: "M88.43,31.04h12.07v3.45H88.43V31.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106866124771930150660000016236687017254087829_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.0204,
    y1: -35.6919,
    x2: 127.8001,
    y2: 71.9459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106866124771930150660000016236687017254087829_)"
    },
    d: "M103.95,31.04h3.45v3.45h-3.45V31.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148619441738616476310000015874509264451176876_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.4515,
    y1: -21.8186,
    x2: 103.2312,
    y2: 85.8192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.98,
    y: 65.52,
    style: {
      fill: "url(#SVGID_00000148619441738616476310000015874509264451176876_)"
    },
    width: 15.52,
    height: 3.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096743597288483979990000012271211053976470674_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2568,
    y1: -27.3554,
    x2: 113.0365,
    y2: 80.2824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096743597288483979990000012271211053976470674_)"
    },
    d: "M103.95,65.52h3.45v3.45h-3.45V65.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047042823088782081910000000528683865376673695_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.7129,
    y1: -24.2249,
    x2: 107.4926,
    y2: 83.4128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047042823088782081910000000528683865376673695_)"
    },
    d: "M88.43,58.62h12.07v3.45H88.43V58.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116202384969940924590000016183512860016979634_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2094,
    y1: -29.0226,
    x2: 115.9891,
    y2: 78.6152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116202384969940924590000016183512860016979634_)"
    },
    d: "M103.95,58.62h3.45v3.45h-3.45V58.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142875428180442997590000008639269377219332782_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.5318,
    y1: -30.334,
    x2: 118.3115,
    y2: 77.3038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142875428180442997590000008639269377219332782_)"
    },
    d: "M93.6,37.93h6.9v3.45h-6.9V37.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130631832844750793850000005055800893599434670_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.0678,
    y1: -34.0247,
    x2: 124.8475,
    y2: 73.6131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130631832844750793850000005055800893599434670_)"
    },
    d: "M103.95,37.93h3.45v3.45h-3.45V37.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176746865726351160120000012615430252043540902_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.5793,
    y1: -28.6668,
    x2: 115.359,
    y2: 78.971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176746865726351160120000012615430252043540902_)"
    },
    d: "M93.6,44.83h6.9v3.45h-6.9V44.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060019387749410964360000007458708002580076189_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.1153,
    y1: -32.3575,
    x2: 121.895,
    y2: 75.2803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060019387749410964360000007458708002580076189_)"
    },
    d: "M103.95,44.83h3.45v3.45h-3.45V44.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121267645538154318220000014804731022063180217_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.6259,
    y1: -26.9991,
    x2: 112.4056,
    y2: 80.6386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121267645538154318220000014804731022063180217_)"
    },
    d: "M93.6,51.72h6.9v3.45h-6.9V51.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129884022356639622150000007174597074013349520_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.162,
    y1: -30.6898,
    x2: 118.9417,
    y2: 76.9479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129884022356639622150000007174597074013349520_)"
    },
    d: "M103.95,51.72h3.45v3.45h-3.45V51.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115494023252775132110000001859048864415002774_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.3421,
    y1: -14.4162,
    x2: 90.1218,
    y2: 93.2216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115494023252775132110000001859048864415002774_)"
    },
    d: "M57.4,58.1c1.11,0.33,2.27,0.52,3.45,0.52 c6.66,0,12.07-5.41,12.07-12.07c0-6.65-5.41-12.07-12.07-12.07c-1.17,0-2.33,0.19-3.45,0.52v-3.54c1.13-0.26,2.27-0.43,3.45-0.43 c8.56,0,15.52,6.96,15.52,15.52S69.4,62.07,60.84,62.07c-1.17,0-2.32-0.17-3.45-0.43V58.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158749383291572535670000016268594354014341032_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.5861,
    y1: -15.6833,
    x2: 92.3658,
    y2: 91.9545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158749383291572535670000016268594354014341032_)"
    },
    d: "M86.71,42.64v7.83l-4.06,1.3l-0.25,0.89 c-0.48,1.7-1.15,3.32-1.99,4.82l-0.45,0.81l1.95,3.78l-5.54,5.53l-3.78-1.94l-0.81,0.45c-1.5,0.84-3.12,1.51-4.82,1.99l-0.89,0.25 l-1.3,4.06H57.4v-7.22c1.13,0.21,2.28,0.33,3.45,0.33c10.46,0,18.97-8.51,18.97-18.96S71.3,27.59,60.84,27.59 c-1.16,0-2.31,0.11-3.45,0.33v-7.22h7.36l1.3,4.06l0.89,0.25c1.7,0.48,3.32,1.15,4.82,1.99l0.8,0.45l3.78-1.95l5.54,5.54 l-1.94,3.78l0.45,0.81c0.84,1.5,1.51,3.12,1.99,4.82l0.25,0.89L86.71,42.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016759992767395324520000005908663963446082233_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5131,
    y1: 60.2755,
    x2: 38.4523,
    y2: 76.877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.82,
    y: 62.07,
    style: {
      fill: "url(#SVGID_00000016759992767395324520000005908663963446082233_)"
    },
    width: 6.9,
    height: 10.34
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.4102a0e078e3e6e45f74d388aa047a40.svg";
export { ForwardRef as ReactComponent };